import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import { getSubject } from "./api";
import { loaderStart, loaderEnd, notification } from "../../components/loader"
import '../Question-bank/questionbank.css';
import './subjectpage.css';

const ALL_LANGUAGES = [
    { name: 'English', native: 'अंग्रेज़ी', code: 'ENG' },
    { name: 'हिन्दी', native: 'Hindi', code: 'HINDI' },
]

const SubjectPage = () => {
    // Honour ?lang= from the Question Bank landing page, so picking a language
    // there actually carries through instead of dropping the visitor onto an
    // empty screen that asks them to choose again.
    const [searchParams, setSearchParams] = useSearchParams()
    const langParam = searchParams.get('lang')

    const [language, setLanguage] = useState(
        langParam === 'ENG' || langParam === 'HINDI' ? langParam : ''
    )
    const [subject, setSubject] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (language) {
            getData()
        }
    }, [language])

    const getData = async () => {
        loaderStart()
        let data = await getSubject(language)
        if (data.code) {
            if (data.data.length) {
                setSubject(data.data)
            } else {
                setSubject([])
                notification(false, "No Subject Available")
            }
        }
        setLoaded(true)
        loaderEnd()
    }

    const chooseLanguage = (code) => {
        setLanguage(code)
        setLoaded(false)
        // Keep the URL in step so the choice survives a refresh or a shared link.
        setSearchParams({ lang: code })
    }

    return (
        <div className='qb_page'>
            <nav className='qb_crumbs'>
                <Link to='/question-bank'>Question Bank</Link>
                <span className='qb_crumb_sep'>/</span>
                <span>Subjects</span>
            </nav>

            <div className='qb_header'>
                <h1 className='qb_title'>Choose a Subject</h1>
                <p className='qb_subtitle'>
                    Select a language, then pick a subject to see its chapters and
                    questions.
                </p>
            </div>

            <div className='qb_lang_grid'>
                {ALL_LANGUAGES.map((l) => (
                    <button
                        type='button'
                        key={l.code}
                        onClick={() => chooseLanguage(l.code)}
                        className={`qb_lang ${language === l.code ? 'is_active' : ''}`}
                    >
                        {l.name}
                        <span className='qb_lang_sub'>{l.native}</span>
                    </button>
                ))}
            </div>

            {subject.length > 0 ? (
                <>
                    <h2 className='qb_section_label'>
                        Subjects
                        <span className='qb_count'>{subject.length} available</span>
                    </h2>

                    <div className='qb_grid'>
                        {subject.map((s) => (
                            // key was missing entirely — React warned on every render
                            // and reused DOM nodes across language switches.
                            <Link
                                key={s.subCode}
                                target='_blank'
                                rel='noreferrer'
                                to={'/chapter-page/' + s.subCode + '/' + language}
                                className='qb_card'
                            >
                                <span className='qb_card_code'>{s.subCode}</span>
                                <p className='qb_card_name'>{s.subName}</p>
                                <span className='qb_card_meta'>
                                    <span className='qb_pill'>{s.total_count}</span>
                                    questions
                                </span>
                                <i className='fa fa-book qb_card_icon' aria-hidden='true'></i>
                            </Link>
                        ))}
                    </div>
                </>
            ) : language && loaded ? (
                <p className='qb_empty'>No subjects are available for this language yet.</p>
            ) : !language ? (
                <p className='qb_empty'>Choose a language above to see the subject list.</p>
            ) : null}
        </div>
    )
}

export default SubjectPage
